import { render } from "./QuestionnairePage.vue?vue&type=template&id=2d6b61ea&scoped=true"
import script from "./QuestionnairePage.vue?vue&type=script&lang=js"
export * from "./QuestionnairePage.vue?vue&type=script&lang=js"

import "./QuestionnairePage.vue?vue&type=style&index=0&id=2d6b61ea&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6b61ea"]])

export default __exports__